import React, { useEffect } from "react";
import { NavLink } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendarAlt } from "@fortawesome/free-solid-svg-icons";
import { pageView } from "../utils/analytics";
import footIcon from "../assets/img/foot-icon.svg";
import footIconCollege from "../assets/img/foot-icon-college.jpg";

/**
 * Home component
 *
 * @param {object} props
 */
const Home = () => {
  useEffect(() => {
    document.title =
      "The Moffat Clinic - Helping you live your life pain free and to the best of your ability.";
  });

  useEffect(() => pageView());

  return (
    <React.Fragment>
      <section className="hero-v2 gs-o-media-island gs-u-align-center">
        <div className="hero-v2__list_item gel-wrap">
          <div className="hero-v2__heading gs-u-pv++ gs-u-pv0@xl">
            <h2 className="gs-u-mb+">Walk Without Pain. Live Without Limits</h2>
            <h3>
              At <b>The Moffat Foot Clinic</b>, we help you move with confidence
              again. From ongoing foot problems to walking & running issues, our
              expert care and modern treatments get you back on your feet -
              quickly, safely, and comfortably.
            </h3>
            <NavLink
              className="button button--large gs-u-pv+ gs-u-ph++ gs-u-mt++"
              to="/foot-clinic"
            >
              Find out more
            </NavLink>
          </div>
          <div>
            <img src={footIcon} alt="" />
          </div>
        </div>
      </section>
      <section className="testimonies spacing-slice gs-u-p++ gs-u-align-center">
        <div className="mini-wrap gs-u-pb+">
          <img src={footIconCollege} alt="" />
          <h2 className="mission-statement gs-u-mb++ gs-u-mt++">
            <span className="gs-u-display-inline-block gs-u-mb++">
              We believe foot health is about more than treatment - it’s about
              confidence, comfort, and quality of life. As a trusted clinic in
              the heart of Moffat, we’ve built lasting relationships with
              families, neighbours, and visitors alike.
            </span>
            <span className="gs-u-display-inline-block gs-u-mb++">
              When you walk through our doors, you’ll always be greeted with a
              smile and treated with the care and respect you deserve.
            </span>
          </h2>
        </div>
        <a
          className="button button--large gs-u-pv+ gs-u-ph++ gs-u-mt++"
          href="/foot-clinic/booking"
        >
          <FontAwesomeIcon icon={faCalendarAlt} className="gs-u-mr" />
          <span>Book now</span>
        </a>
      </section>
    </React.Fragment>
  );
};

export default Home;
